import styled from 'styled-components/macro';
import { Image } from '@yme/atoms/image';
export const ImageLink = styled.a `
  display: block;
`;
export const ImageAtomStyled = styled(Image) `
  & img {
    width: 100%;
    height: auto;
  }
`;
